import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AtmTextUiComponent } from './atm-text-ui.component';

@NgModule({
  declarations: [AtmTextUiComponent],
  imports: [CommonModule],
  exports: [AtmTextUiComponent],
})
export class AtmTextUiModule {}
